import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Account } from '@shared/models';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '@core/services/account.service';
import { FeedBackService } from 'src/app/portal/feedback/services/feedback.service';
import { switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'gcc-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
  standalone: false
})
export class UserInfoComponent {
  @Input() public user: Account;
  @Output() public logout: EventEmitter<void> = new EventEmitter();

  public mailtoLink: string;

  private mailAddress = 'GCCFeedback@deloitte.com';
  private mailSubject: string;

  constructor(
    private translate: TranslateService,
    public accountService: AccountService,
    public feedBackService: FeedBackService
  ) {
    this.translate.get('header.user_info.mail_subject').subscribe(value => {
      this.mailSubject = value;
      this.mailtoLink = `mailto:${this.mailAddress}?Subject=${this.mailSubject}`;
    });
  }

  public onLogout() {
    this.logout.emit();
  }

  public onCookieSettings(event: Event): void {
    event.preventDefault();

    window['Optanon']?.ToggleInfoDisplay();
  }

  surveyHandler(): void {
    this.feedBackService.start().subscribe(value => {});
  }
}
